<div class="page">
    <div class="title">
        <div class="titleValue">Configuración</div>
        <div class="line"></div>
    </div>

    <div class="buttonsGroup" *ngIf="sectionSelected === sections.configuracion">
        <div class="buttonsGroupConfiguracion">
            <div class="buttonConfig" (click)="goToPreferenciasCuenta()"><mat-icon class="buttonIcon">person</mat-icon>Preferencias de la cuenta</div>
            <div class="buttonConfig"><mat-icon class="buttonIcon">notifications</mat-icon>Notificaciones</div>
        </div>
    </div>
</div>
